import { request } from "services/api/util";

class ProductCategoryService {
  async getListProductCategory(param) {
    const config = {
      method: "get",
      url: `admin/productCategory`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new ProductCategoryService();
